import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ArgoVideoShort } from '../../interfaces';

@Component({
  selector: 'outlaw-playlist-item',
  templateUrl: './playlist-item.component.html',
  styleUrls: ['./playlist-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaylistItemComponent {
  @Input() video: ArgoVideoShort;
  @Input() isSelected = false;
  @Output() itemClick = new EventEmitter<ArgoVideoShort>();
}
